import React, { useEffect } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import HeroSection from "../../layout/HeroSection";
import Loader from "../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../routes/pageRoutes";
import Rules from "./Rules";
import { fetchSparcRule } from "../../redux/action/getStartAction";

const SparcRule = () => {
  const dispatch = useDispatch();
  const { sparcRuleList,isLoading } = useSelector((state) => state?.getStartReducer);

  useEffect(() => {
    dispatch(fetchSparcRule())
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Header />
      <HeroSection
        label={<h1 class="mb-3">{"SPARC Rules, NHRL Rules, Battlebots! Rules"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}/` },
          { name: "SPARC Rules, NHRL Rules, Battlebots! Rules", path: `${pageRoutes?.home}/` },
        ]}
      />
      <div class="untree_co-section product-section py-5 my-5">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <h2 class="section-title text-center pb-5">
                <strong>
                  Standardized Procedures for the Advancement of Robot Combat
                  (SPARC)
                </strong>
              </h2>
            </div>
          </div>
          <Rules />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SparcRule;
